/**
 * Uzbek strings of what a tour result owes the operator besides its price: supplier states, the
 * four options, the hotel panel, price age and distances. Spread into `uz`. The `tourinfo.` prefix
 * keeps them out of `ru-09-tours`' exhaustive record; `ru-09-tour-info` is their own.
 */
export const uzTourInfo09 = {
  "tourinfo.status.title": "Provayderlar holati",
  "tourinfo.group.working": "Qidirilmoqda",
  "tourinfo.group.answered": "Javob berdi",
  "tourinfo.group.failed": "Xato — provayder javob bermadi",
  "tourinfo.group.notSelling": "Bu yo'nalishni sotmaydi yoki bog'lanmagan",
  "tourinfo.chip.pending": "Navbatda",
  "tourinfo.chip.running": "Qidirilmoqda",
  "tourinfo.chip.results": "{count} natija",
  "tourinfo.chip.none": "Natija yo'q",
  "tourinfo.chip.noDestination": "Bu yo'nalish yo'q",
  "tourinfo.chip.notCovered": "Qamrab olinmagan",
  "tourinfo.chip.error": "Xato",
  "tourinfo.chip.skipped": "O'tkazib yuborildi",
  "tourinfo.partial.title": "Natijalar to'liq emas: {count} ta provayder javob bermadi.",
  "tourinfo.partial.fallback": "Provayder vaqtincha ishlamayapti.",
  "tourinfo.empty.partial":
    "Javob bergan provayderlarda taklif yo'q, qolganlari javob bermadi. Bu «natija yo'q» degani emas: birozdan so'ng qayta qidiring.",
  "tourinfo.empty.noSupplier": "Ulangan provayderlar bu yo'nalishni sotmaydi. Boshqa yo'nalishni tanlang.",
  "tourinfo.truncated": "Jami {total} ta taklifdan {shown} tasi ko'rsatilgan, filtrlar shular ichida ishlaydi.",

  "tourinfo.age.now": "Narx hozirgina olingan",
  "tourinfo.age.minutes": "Narx {count} daqiqa oldin olingan",
  "tourinfo.age.hours": "Narx {count} soat oldin olingan",
  "tourinfo.age.days": "Narx {count} kun oldin olingan",
  "tourinfo.age.stale": "Narx eskirgan, qayta tekshiring",

  "tourinfo.source": "Manba: {source}",
  "tourinfo.source.agency": "agentlik o'lchovi",
  "tourinfo.source.routed": "yo'l xizmati",
  "tourinfo.source.straight": "koordinatalar bo'yicha, to'g'ri chiziq",
  "tourinfo.source.provider": "provayder ma'lumoti",
  "tourinfo.airport.value": "Aeroportgacha {km} km, {minutes} daqiqa",
  "tourinfo.airport.approx": "Aeroportgacha {km} km, taxminan {minutes} daqiqa",
  "tourinfo.airport.unknown": "Aeroportgacha: joylashuv aniqlanmagan",
  "tourinfo.beach.value": "Plyajgacha {metres} m",
  "tourinfo.beach.none": "Plyajgacha: o'lchov kiritilmagan",
  "tourinfo.location.unmatched": "Mehmonxona katalogga bog'lanmagan: joylashuv aniqlanmagan",
  "tourinfo.distance.failed": "Masofani olib bo'lmadi.",

  "tourinfo.variants.title": "To'rt variant",
  "tourinfo.slot.cheapest": "Arzon",
  "tourinfo.slot.middle": "O'rta",
  "tourinfo.slot.premium": "Premium",
  "tourinfo.slot.halal": "Halol",
  "tourinfo.variants.budget": "Byudjet, {currency}",
  "tourinfo.variants.none": "Bu qidiruvda mos variant topilmadi",
  "tourinfo.variants.premiumNone": "Byudjet chegarasida premium variant topilmadi",
  "tourinfo.variants.currency": "To'rt variant faqat USD va so'mdagi takliflardan tanlanadi.",
  "tourinfo.variants.failed": "Variantlarni yuklab bo'lmadi.",

  "tourinfo.panel.open": "Tahlil",
  "tourinfo.panel.distances": "Masofalar",
  "tourinfo.panel.warnings": "Ogohlantirishlar",
  "tourinfo.panel.facts": "Ma'lumotlar",
  "tourinfo.panel.pros": "Afzalliklar",
  "tourinfo.panel.cons": "Kamchiliklar",
  "tourinfo.panel.missing": "Tizimda yo'q",
  "tourinfo.panel.failed": "Tahlilni yuklab bo'lmadi.",
  "tourinfo.notes.title": "Agentlik eslatmalari",
  "tourinfo.notes.empty": "Hali eslatma yo'q.",
  "tourinfo.notes.failed": "Eslatmalarni yuklab bo'lmadi.",
  "tourinfo.notes.kind": "Turi",
  "tourinfo.notes.kind.complaint": "Shikoyat",
  "tourinfo.notes.kind.renovation": "Ta'mirlash",
  "tourinfo.notes.kind.other": "Boshqa",
  "tourinfo.notes.text": "Eslatma",
  "tourinfo.notes.save": "Saqlash",
  "tourinfo.notes.saveFailed": "Eslatmani saqlab bo'lmadi.",
} as const;
